import React from 'react';
import { Section } from './ui/Section';
export function SevenDayPlan() {
  const days = [{
    day: 'Día 1',
    task: 'Eliges idea (con Heylloyd + método 3P)'
  }, {
    day: 'Día 2',
    task: 'Creas la estructura completa'
  }, {
    day: 'Día 3',
    task: 'Expandes capítulos (sin escribir desde cero)'
  }, {
    day: 'Día 4',
    task: 'Preparas tu prompt para Gamma'
  }, {
    day: 'Día 5',
    task: 'Generas tu PDF y lo descargas'
  }, {
    day: 'Día 6',
    task: 'Armas tu oferta + mensajes para WhatsApp'
  }, {
    day: 'Día 7',
    task: 'Publicas, contactas y haces ventas'
  }];
  return <Section className="bg-brand-dark text-white !pb-6 md:!pb-10" data-id="element-479">
      <div className="text-center mb-8 md:mb-12" data-id="element-480">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-3" data-id="element-481">
          El Plan "7 Días"
        </h2>
        <p className="text-gray-400 text-sm md:text-base" data-id="element-482">
          (para mamás ocupadas)
        </p>
      </div>

      <div className="max-w-3xl mx-auto" data-id="element-483">
        <div className="space-y-3 md:space-y-4" data-id="element-484">
          {days.map((item, i) => <div key={i} className="flex items-center bg-gray-800/50 p-3 md:p-4 rounded-xl border border-gray-700" data-id="element-485">
              <div className="bg-brand-pink text-brand-dark font-bold px-2 md:px-3 py-1 rounded-md mr-3 md:mr-4 min-w-[65px] md:min-w-[80px] text-center text-sm md:text-base" data-id="element-486">
                {item.day}
              </div>
              <div className="text-gray-200 font-medium text-sm md:text-base" data-id="element-487">
                {item.task}
              </div>
            </div>)}
        </div>

        <div className="text-center mt-8" data-id="element-488">
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-489">
            No necesitas perfección. <br data-id="element-490" />
            <span className="text-brand-pink" data-id="element-491">Necesitas terminar.</span>
          </p>
        </div>
      </div>
    </Section>;
}